const auth = {
    state: () => (
        {
            autenticado: false,
            usuario: {
              codigo: -1,
              login: '',
              nome: '',
              email: '',
              nivelAcesso: {
                pesquisa: 0,
                parametros: 0,
                etiquetas: 0,
              }
            }
          }),
        getters: {
            getCodigoUsuario: (state) => state.usuario.codigo,
            getUsuarioLogado: (state) => state.autenticado,
            getNivelPesquisa: (state) => state.usuario.nivelAcesso.pesquisa,
            getNivelParametros: (state) => state.usuario.nivelAcesso.parametros,
            getNivelEtiquetas: (state) => state.usuario.nivelAcesso.etiquetas,
        },
        mutations: {
            defineDadosUsuario({ usuario }, dadosUsuario){
                usuario.login = dadosUsuario.login
                usuario.nome = dadosUsuario.nome
                usuario.email = dadosUsuario.email
                usuario.nivelAcesso = dadosUsuario.nivelAcesso
            },
            login(state, codigoUsuario){
                state.usuario.codigo = codigoUsuario
                state.autenticado = codigoUsuario > 0
            },
            logout(state){
                state.usuario.codigo = -1
                state.usuario.nome = ''
                state.usuario.email = ''
                state.usuario.nivelAcesso = {
                    pesquisa: 0,
                    parametros: 0,
                    etiquetas: 0,
                }
                state.autenticado = false
            }
        },
        actions: {
        },
        modules: {
        },
  }

  export default auth